"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveStoredTheme = resolveStoredTheme;
function resolveStoredTheme(stored, deviceIsDark) {
    if (stored === "light" || stored === "dark")
        return stored;
    if (stored === "system")
        return deviceIsDark ? "dark" : "light";
    return "light";
}
//# sourceMappingURL=storedTheme.js.map